import { Utils } from "core/utils";

export class HttpService {

    static ApiBase = "https://jobflowconnect.com/api"; 
    // static ApiBase = "http://127.0.0.1:8000"; 
    static SiteBase = "https://jobflowconnect.com";
    static TOKEN_KEY = "jfc.auth.access_token";
    static USER_KEY = "jfc.auth.user";
    static LEGACY_TOKEN_KEY = "0mXcz!23_#^kls92p&*ytPLmn";
    static LEGACY_USER_KEY = "user";

    headers = new Headers();
    
    static getToken = () => {
        const token = localStorage.getItem(HttpService.TOKEN_KEY);
        if (token) return token;

        const legacyToken = localStorage.getItem(HttpService.LEGACY_TOKEN_KEY);
        if (legacyToken) {
            localStorage.setItem(HttpService.TOKEN_KEY, legacyToken);
            localStorage.removeItem(HttpService.LEGACY_TOKEN_KEY);
        }

        return legacyToken || null;
    };

    static setToken = (token) => {
        localStorage.setItem(HttpService.TOKEN_KEY,token);
    };

    static setUser = (user) => {
        localStorage.setItem(HttpService.USER_KEY,JSON.stringify(user));
    };

    static getUser = () => {
        let userObj = localStorage.getItem(HttpService.USER_KEY) || null
        if (!userObj) {
            const legacyUserObj = localStorage.getItem(HttpService.LEGACY_USER_KEY) || null;
            if (!legacyUserObj) return null;
            localStorage.setItem(HttpService.USER_KEY, legacyUserObj);
            localStorage.removeItem(HttpService.LEGACY_USER_KEY);
            userObj = legacyUserObj;
        }
        return JSON.parse(userObj);
    };

    static signOut = () => {
        localStorage.removeItem(HttpService.TOKEN_KEY);
        localStorage.removeItem(HttpService.USER_KEY);
        localStorage.removeItem(HttpService.LEGACY_TOKEN_KEY);
        localStorage.removeItem(HttpService.LEGACY_USER_KEY);
    };

    getUserToken = () => {
        const token = localStorage.getItem(HttpService.TOKEN_KEY);
        return token;
      };

    setHeaders() {
       this.headers.append("Content-Type", "application/json");
       this.headers.append("Accept", "application/json");    
        const auth = this.getUserToken();
        if (auth) this.headers.append("Authorization", "Bearer " + auth);

    }

    

    async get(url, params) {
        // Create and set headers
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");   
        const auth = this.getUserToken();
        if (auth) {
          headers.append("Authorization", "Bearer " + auth);
        }   
      
        // Build the full URL with query parameters if provided
        let fullUrl = `${HttpService.ApiBase}${url}`;
        if (params && typeof params === "object") {
          const queryString = new URLSearchParams(params).toString();
          fullUrl += (url.includes('?') ? '&' : '?') + queryString;
        }

      
        // Make the GET request
        const response = await fetch(fullUrl, {
          headers: headers,
          method: 'GET',
        });
      
        const data = await response.json();
      
        // Handle unauthorized access
        if (response.status === 401) {
            Utils.removeUserSession();
        //   window.location.reload();
        console.log("401 Error at get request ", url)
        }
      
        return data;
      }
      

    async post(url,body,hasFile)  {
        console.log("POST : " + url);
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        // headers.append("Access-Control-Allow-Origin", "*")

        const auth = this.getUserToken();
        if (auth!= null) headers.append("Authorization", "Bearer " + auth); 
        
        const response = await fetch(`${HttpService.ApiBase}${url}`, {
            headers: headers,
            method: 'POST',
            body: hasFile ? body : JSON.stringify(body),
        });


        console.log(response)
        
        if (!response.ok) {
            let errorData;
            try {
                const text = await response.text();
                errorData = text ? JSON.parse(text) : { error: 'Unknown error' };
            } catch (parseError) {
                errorData = { error: `HTTP error! status: ${response.status}`, detail: await response.text().catch(() => 'Could not read error response') };
            }
            const errorMessage = errorData.error || errorData.detail || `HTTP error! status: ${response.status}`;
            console.error('API Error:', errorData);
            throw new Error(errorMessage);
        }
        
        // Try to parse JSON, but handle empty responses gracefully
        try {
            const text = await response.text();
            // If response body is empty, return success object
            if (!text || text.trim() === '') {
                return { success: true, status: response.status };
            }
            // Try to parse as JSON
            try {
                return JSON.parse(text);
            } catch (jsonError) {
                // If JSON parsing fails but response was ok (2xx), return success
                if (response.status >= 200 && response.status < 300) {
                    return { success: true, status: response.status, raw: text };
                }
                throw jsonError;
            }
        } catch (error) {
            // If reading the response fails but status is ok, return success
            if (response.status >= 200 && response.status < 300) {
                return { success: true, status: response.status };
            }
            throw error;
        }
    }

    async put(url,body,hasFile=false)  {

        console.log(JSON.stringify(body))

        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${HttpService.ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PUT',
            body: hasFile ? body : JSON.stringify(body),
        });

        const data = await response.json();

        // console.log(response.body)


        return data;
    }

    async patch(url,body,hasFile)  {
        
        var headers = new Headers();
        if(!hasFile)
            headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   
        
        const response = await fetch(`${HttpService.ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PATCH',
            body: hasFile ? body : JSON.stringify(body),
        });

        const data = await response.json();

        return data;
    }

    async delete(url) {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   

        const response = await fetch(`${HttpService.ApiBase}${url}`, {
        headers: new Headers(headers),
        method: 'DELETE',
        });

        // Handle unauthorized access
        if (response.status === 401) {
            Utils.removeUserSession();
            console.log("401 Error at delete request ", url)
        }

        const data = await response.json().catch(() => ({}));
        
        if (!response.ok) {
            throw { response: { data, status: response.status } };
        }
        
        return data;
    }

    async updateActive(url,is_active) {
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json"); 
        const auth = this.getUserToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);   

        var body = {
            "is_active" : is_active
        }

        const response = await fetch(`${HttpService.ApiBase}${url}`, {
            headers: new Headers(headers),
            method: 'PATCH',
            body: JSON.stringify(body),
        });

        const data = await response.json();

        return data;
    }

    

    
}

